module.exports = __webpack_public_path__ + "img/banner.88590bd9.png";